import React, { useState, useEffect } from 'react';
import { getAppointment } from '../../redux/deals/action';
import { connect } from 'react-redux';
import { cancelAppointment } from '../../api/Agenda/agenda.api';
import RescheduleMeeting from '../agenda/rescheduleMeeting/RescheduleMeeting';
import Confirmation from '../confirmation/ConfirmationComponent';
import dayjs from 'dayjs';
import styles from './MeetingStatus.module.scss';
import { MoreVertOutlined } from '@mui/icons-material';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import IconButton from '@mui/material/IconButton';
import { setAlert } from '../../redux/alerts/action';

const MeetingStatus = ({
	appointment,
	getAppointment,
	appointmentDetails,
	leadId,
	setAlert,
}) => {
	const [loading, setLoading] = useState(false);
	const [open, setOpen] = useState(false);
	const [rescheduleModal, setRescheduleModal] = useState(false);
	const [confirmModal, setConfirmModal] = useState(false);
	const anchorRef = React.useRef(null);
	// return focus to the button when we transitioned from !open -> open
	const prevOpen = React.useRef(open);

	useEffect(() => {
		if (prevOpen.current === true && open === false) {
			anchorRef.current.focus();
		}

		prevOpen.current = open;
	}, [open]);

	useEffect(() => {
		if (loading === true && rescheduleModal === false) {
			getAppointment(leadId);
		}
	}, [rescheduleModal]);

	const handleToggle = () => {
		setOpen((prevOpen) => !prevOpen);
	};

	const handleClose = (event) => {
		if (anchorRef.current && anchorRef.current.contains(event.target)) {
			return;
		}

		setOpen(false);
	};

	function handleListKeyDown(event) {
		if (event.key === 'Tab') {
			event.preventDefault();
			setOpen(false);
		} else if (event.key === 'Escape') {
			setOpen(false);
		}
	}

	const handleCancelMeeting = () => {
		setOpen(false);
		setConfirmModal(true);
	};

	const handleReschedule = () => {
		setOpen(false);
		setRescheduleModal(true);
	};
	const handleRescheduleModalClose = () => {
		setRescheduleModal(false);
	};
	const handleCloseConfirmation = () => {
		setConfirmModal(false);
	};
	const confirmBtnList = [
		{
			name: 'Confirm',
			action: () => {
				handleCloseConfirmation();
				cancelAppointment(appointment?.appointmentID, (returned) => {
					setAlert('success', returned);
				});
			},
			style: {
				color: 'var(--white)',
				backgroundColor: 'var(--primary)',
				fontWeight: '700',
				width: '175px',
				height: '42px',
			},
		},
		{
			name: 'Cancel',
			action: () => {
				handleCloseConfirmation();
			},
			style: {
				color: 'var(--primary)',
				fontWeight: '700',
				width: '175px',
				height: '42px',
			},
		},
	];
	return (
		<div className={styles.meetingStatusWrapper}>
			<div>
				{dayjs(appointmentDetails?.timeOfAppointment).format(
					'dddd, MMM DD, YYYY | hh:mm A'
				)}
				&nbsp;-&nbsp;
				{dayjs(appointmentDetails?.timeOfAppointment)
					.add(30, 'minute')
					.format('hh:mm A')}
			</div>
			<div>
				<IconButton
					style={{ padding: 0 }}
					ref={anchorRef}
					id='composition-button'
					aria-controls={open ? 'composition-menu' : undefined}
					aria-expanded={open ? 'true' : undefined}
					aria-haspopup='true'
					onClick={handleToggle}
				>
					<MoreVertOutlined />
				</IconButton>
				<Popper
					open={open}
					anchorEl={anchorRef.current}
					role={undefined}
					placement='bottom-start'
					transition
					disablePortal
				>
					{({ TransitionProps }) => (
						<Grow {...TransitionProps}>
							<Paper>
								<ClickAwayListener onClickAway={handleClose}>
									<MenuList
										autoFocusItem={open}
										id='composition-menu'
										aria-labelledby='composition-button'
										onKeyDown={handleListKeyDown}
									>
										<MenuItem onClick={handleCancelMeeting}>
											Cancel Meeting
										</MenuItem>
										<MenuItem
											onClick={handleReschedule}
											className={styles.borderY}
										>
											Reschedule
										</MenuItem>
										{/* <MenuItem onClick={handleClose}>
											View Comments
										</MenuItem> */}
									</MenuList>
								</ClickAwayListener>
							</Paper>
						</Grow>
					)}
				</Popper>
				{appointment && (
					<RescheduleMeeting
						rescheduleModal={rescheduleModal}
						appointmentId={appointment?.appointmentID}
						handleRescheduleModalClose={handleRescheduleModalClose}
						appointmentTime={appointment?.timeOfAppointment}
						setLoading={setLoading}
					/>
				)}
				{confirmModal && (
					<Confirmation
						open={confirmModal}
						handleClose={handleCloseConfirmation}
						title={'Cancel Appointment'}
						dialogContent={
							'Are you sure do you want to cancel the appointment?'
						}
						buttonList={confirmBtnList}
					/>
				)}
			</div>
		</div>
	);
};

const mapStateToProps = (state) => ({
	appointmentDetails: state.leads.appointmentDetailByLeadId,
});

export default connect(mapStateToProps, { getAppointment, setAlert })(
	MeetingStatus
);
